// extracted by mini-css-extract-plugin
export default {"history-transactions-component":"FollowerHistoryTransactionsComponent_history-transactions-component__j-IU+","mobile":"FollowerHistoryTransactionsComponent_mobile__Dq1pb"};